import React, {useContext, useState} from 'react';
import {OrderViewContext} from "./OrderViewContext";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {exportXLSXFile} from "../../utils/exportCSVFile";
import DynaDatePicker from "../A13/DynaView/DynaDatePicker";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";

function TableButtons(props) {

  const helper = useContext(OrderViewContext);
  const data = helper.data
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isExporting, setIsExporting] = useState(false);

  const navigateTo = useNavigate()
  console.log(data)

  const compareJalaliDates = (first, second) => {
    const firstParts = first.split("/").map(Number);
    const secondParts = second.split("/").map(Number);
    for (let index = 0; index < 3; index += 1) {
      if (firstParts[index] !== secondParts[index]) {
        return firstParts[index] - secondParts[index];
      }
    }
    return 0;
  };

  const validDateRange = startDate && endDate && compareJalaliDates(startDate, endDate) <= 0;

  // نرمال‌سازی تاریخ شمسی تا ماه و روز یک‌رقمی (مثل 1402/12/7) درست مقایسه شوند
  const normalizeJalaliDate = (date) => {
    if (!date) return "";
    return date
      .toString()
      .split("/")
      .map((part, index) => (index === 0 ? part : part.padStart(2, "0")))
      .join("/");
  };

  const handleExport = async () => {
    if (!validDateRange || isExporting) return;

    setIsExporting(true);
    try {
      // فیلتر بازه تاریخ سمت کلاینت اعمال می‌شود تا سفارش‌هایی که تاریخ ثبت آن‌ها
      // با ماه/روز یک‌رقمی ذخیره شده است (مثلاً 1402/12/7) از خروجی حذف نشوند.
      const filter = {
        startDate: "",
        endDate: "",
        paymentStatus: data.filter?.paymentStatus || "all",
      };
      const response = await _axios.get(
        `${prefixUrl()}/cartTable/?request=tableData&filter=${encodeURIComponent(JSON.stringify(filter))}`,
      );
      const report = response?.data;
      if (!report?.status || !Array.isArray(report.data) || report.data.length === 0) {
        toast.error(report?.message || "برای بازه انتخاب‌شده سفارشی وجود ندارد");
        return;
      }

      const headers = {};
      report.columns?.forEach((column) => {
        if (column.field && column.title) headers[column.field] = column.title;
      });
      const headerFields = Object.keys(headers);

      const normalizedStart = normalizeJalaliDate(startDate);
      const normalizedEnd = normalizeJalaliDate(endDate);
      const exportData = report.data
        .filter((row) => {
          const rowDate = normalizeJalaliDate(row.orderDate);
          return rowDate !== "" && rowDate >= normalizedStart && rowDate <= normalizedEnd;
        })
        .map((row) => {
          const normalizedRow = { ...row, orderDate: normalizeJalaliDate(row.orderDate) };
          if (headerFields.length === 0) return normalizedRow;
          // فقط ستون‌هایی که در جدول نمایش داده می‌شوند در خروجی بیایند
          return headerFields.reduce((picked, field) => {
            picked[field] = normalizedRow[field];
            return picked;
          }, {});
        });

      if (exportData.length === 0) {
        toast.error("برای بازه انتخاب‌شده سفارشی وجود ندارد");
        return;
      }

      const priceFields = Array.isArray(report.priceFields) ? report.priceFields : [];
      const fileRange = `${startDate}_${endDate}`.replace(/\//g, "-");
      exportXLSXFile(exportData, `OrderList_${fileRange}`, headers, { priceFields });
    } catch (error) {
      toast.error("خطا در دریافت اطلاعات خروجی اکسل");
    } finally {
      setIsExporting(false);
    }
  };

  return (<div>

    <div className={"d-flex flex-wrap align-items-end"} style={{gap: 12}}>

      <button
        className={"theme1__btn theme1__btn__main"}
        onClick={() => {
          navigateTo('/OrdersSadan')
        }}
      >
        افزودن سفارش
      </button>
      <div style={{width: 190}}>
        <DynaDatePicker
          label="از تاریخ گزارش اکسل"
          name="exportStartDate"
          className="solid-dyna-input"
          value={startDate}
          maxDate={endDate || undefined}
          setDataFromComponent={(value) => setStartDate(value.exportStartDate)}
        />
      </div>
      <div style={{width: 190}}>
        <DynaDatePicker
          label="تا تاریخ گزارش اکسل"
          name="exportEndDate"
          className="solid-dyna-input"
          value={endDate}
          setDataFromComponent={(value) => setEndDate(value.exportEndDate)}
        />
      </div>
      <button
        className={"theme1__btn mx-2"}
        onClick={handleExport}
        disabled={!validDateRange || isExporting}
      >
        {isExporting ? "در حال آماده‌سازی..." : "خروجی اکسل"}
      </button>
      {/*<button*/}
      {/*  className={"theme1__btn"}*/}
      {/*  onClick={() => {*/}


      {/*    if (data?.selectedRowId) {*/}
      {/*      navigateTo('/OrdersSadan',{state: {id: data?.selectedRowId}})*/}
      {/*    } else {*/}
      {/*    toast('برای ویرایش باید یک سطر را انتخاب کنید.')*/}

      {/*    }*/}
      {/*  }}*/}
      {/*>*/}
      {/*  ویرایش سفارش*/}
      {/*</button>*/}
    </div>

  </div>);
}

export default TableButtons;
